<template>
    <Impostazioni :show_gestione_reparto="true" :rotta_back="'/home/electrical'" />
</template>
<script>
import Impostazioni from "@/views/PRODUCTION/Impostazioni/Impostazioni.vue";

export default {
  name: "EMImpostazioni",
  components: {Impostazioni},
  props: {},
  data() {
    return {
        // Variabili d'appoggio
        // Modal
        // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {

  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>